.bookmarks {
  width: 100%;
}

.bookmarkTiles {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: flex-start;
}

.favoriteResources {
  font-family: var(--font-family-heading);
  font-size: var(--font-size-2xl);
  color: var(--color-text);
  line-height: 1.05;
  letter-spacing: -0.04em;
  margin-bottom: 2rem;
  margin-top: 0px;
}

.favoriteMentors {
  font-family: var(--font-family-heading);
  font-size: var(--font-size-2xl);
  color: var(--color-text);
  line-height: 1.05;
  letter-spacing: -0.04em;
  margin-top: 50px;
  margin-bottom: 2rem;
}

.mentorBookmarkTiles {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
